import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Qué pasa entre las sesiones de SAINT®?",
    answer:
      "Entre las sesiones de SAINT® hay descansos de aproximadamente 50 minutos. El paciente permanece en la clínica y puede descansar, leer o usar su teléfono. No hay anestesia ni sedación.",
  },
];

export const esBetweenSessions = makeEsArticle({
  slug: "what-happens-between-saint-sessions",
  title: "Qué pasa entre las sesiones de SAINT®",
  description:
    "Entre las sesiones de SAINT® hay descansos de unos 50 minutos. El paciente permanece despierto en la clínica durante la semana de tratamiento.",
  h1: "¿Qué pasa entre las sesiones de SAINT®?",
  breadcrumbLabel: "Entre sesiones de SAINT®",
  shortAnswer:
    "SAINT® administra aproximadamente 10 sesiones por día durante cinco días, con descansos de aproximadamente 50 minutos entre sesiones. Cada sesión de estimulación dura unos minutos. Entre sesiones, el paciente permanece despierto en la clínica y puede descansar, leer o usar su teléfono. No se usa anestesia ni sedación. La semana completa se completa en cinco días consecutivos.",
  keyTakeaways: [
    "SAINT® administra unas 10 sesiones por día durante cinco días.",
    "Los descansos entre sesiones son de aproximadamente 50 minutos.",
    "El paciente permanece despierto entre sesiones.",
    "No se usa anestesia ni sedación.",
    "La semana completa se completa en cinco días consecutivos.",
  ],
  sections: [
    {
      heading: "El ritmo del día",
      paragraphs: [
        "Cada día de tratamiento de SAINT® incluye aproximadamente 10 sesiones de estimulación, cada una de unos minutos, separadas por descansos de aproximadamente 50 minutos. El paciente permanece despierto y alerta durante todo el día y puede descansar entre sesiones.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
